module.exports = {
  name: "Nasnav",
  desc: "Nasnav - Dashboard",
  prefix: "Nasnav",
  footerText: "Nasnav All Rights Reserved 2019",
  logoText: "Nasnav",
};
